import { dwellsyApi } from "api/dwellsy";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const DwellsyView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectDwellsy, isPending: isDisconnecting } = useMutation(
    {
      mutationKey: ["DWELLSY", "DELETE"],
      mutationFn: () => dwellsyApi.disconnect(),
      onSuccess: () => {
        toast.success("Dwellsy integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    }
  );

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.DWELLSY}
          name="Dwellsy"
          path="/settings/integration/dwellsy"
          onDisconnect={() => disconnectDwellsy()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <FeedListingsCard feed="dwellsy" feedLabel="Dwellsy" />
    </Layout>
  );
};
